<body>
  <h1>
    {{ video?.title || "Error 404: Video Not Found" }}
  </h1>
  <section>
    <div class="left">
      <app-video-player
        [video]="video"
        (onSceneSelected)="sceneSelected($event)"
        (onScenesLoaded)="scenesLoaded()"
      >
      </app-video-player>
    </div>
    <div class="right">
      @if (!isLoading()) {
      <!-- Display the video scene data -->
      @if(card){
      <app-horizontal-card
        [card]="card"
        (onChange)="cardChanges($event)"
        (onDelete)="cardDeleted($event)"
      ></app-horizontal-card>
      } @else {
      <div class="card-error">
        <p>
          No se ha detectado ninguna escena para esta parte del video. Elige una
          escena del video o espere a que el reproductor de video avance
          automáticamente hasta la siguiente escena.
        </p>
      </div>
      }
      <!-- Loading state -->
      } @else {
      <div class="loader-container">
        <div class="loader-wrapper">
          <div class="loader"></div>
        </div>
      </div>
      }
    </div>
  </section>
</body>
